import gql from 'graphql-tag'
import {
  GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS,
  GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS, GQL_PROJECT_CHATGPT_RESPONSES_API_DEFAULT_FIELDS,
  GQL_PROJECT_DEFAULT_FIELDS,
} from '@/components/projects/graphql/graphql.const.ts'

export const FindProjectsQuery = gql`
  query FindProjects {
    projects: findProjects {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }`

export const FindProjectsCompactQuery = gql`
  query FindProjects {
    projects: findProjects {
      id
      title
      key
    }
  }
`

// TODO: Make common fields-variable with CreateOrUpdateProjectMutation
export const FindProjectAndAllUsers = gql`
  query FindProjectAndAllUsers($input: FindProjectsInput) {
    users: findUsers {
      id
      firstname
      lastname
      username
    }
    projects: findProjects(input: $input) {
      id
      title
      description
      key
      userIds
    }
  }
`

export const FindProjects_WidgetAssistantPhotos_PlatformLanguages = gql`
  query FindProjects_WidgetAssistantPhotos_PlatformLanguages ($input: FindProjectsInput, $projectId: Uint!) {
    projects: findProjects (input: $input) {
      settings {
        widgetAssistantBehaviour {
          initialMessage
          delayBeforeResponseMs
          initialMessageTypingDelayMs
          initialMessageSendingDelayAfterTypingEndedMs
        }
        widgetVisual {
          color
          avatarUrl
          gradients {
            enabled
            degree
            colors
          }
          margins {
            horizontalPx
            verticalPx
            position
          }
        }
        widgetLocalization {
          default
          locale
          assistantName
          assistantBadge
          initialMessage
          userMessagePlaceholder
        }
        security {
          banIpChatsLimitChats
          maxChatsPerTimeChats
          maxChatsPerTimeSeconds
          aiQuitMessagesThreshold
          maxMessagesPerTimeSeconds
          maxMessagesPerTimeMessages
          maxChatMessagesPerTimeSeconds
          banIpChatsLimitIntervalSeconds
          maxChatMessagesPerTimeMessages
          maxChatMessagesPerTimeBanMinutes
          banIpChatsLimitIntervalBanTimeMinutes
        }
        common {
          chatAliveForXMinutes
        }
        ai {
          type
          chatGptModel
          chatGptInitialTask
        }
      }
    }

    languages: getPlatformLanguages {
      id
      title
      locale
    }

    widgetAssistantPhotos: getWidgetAssistantPhotos(projectId: $projectId) {
      ${GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS}
    }
  }
`

export const GetProjectChatGPTModelsAndProjectFiles = gql`
  query GetProjectChatGPTAssistantInfo($projectId: Uint!) {

    chatGptModels: getProjectChatGptModels(projectId: $projectId) {
      ID
    }

    files: getChatGptAssistantFiles (projectId: $projectId) {
      ${GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS}
    }
  }
`

export const GetPlatformLanguages = gql`
  query GetPlatformLanguages {
    languages: getPlatformLanguages {
      id
      title
      locale
    }
  }
`
